import script from "./footerComp.vue?vue&type=script&setup=true&lang=js"
export * from "./footerComp.vue?vue&type=script&setup=true&lang=js"

import "./footerComp.vue?vue&type=style&index=0&id=6c272c5f&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6c272c5f"]])

export default __exports__